// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app/styles/" + chunkId + "." + {"5688":"aee67b47971f239eacc4","7852":"26b46523fe3ae8eea8d8"}[chunkId] + ".css";
};